import React, {useState} from 'react'
import Button from 'lib/ui/Button'
import Dialog from 'lib/ui/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import TestAttendeeSearchField from 'organization/Event/Form/TestTagButton/TestAttendeeSearchField'
import styled from 'styled-components'
import {Attendee} from 'Event/attendee'
import SuccessAlert from 'lib/ui/alerts/SuccessAlert'
import CompletedTestForm from 'organization/Event/Form/WebhookTest/CompletedTestForm'
import {Form} from 'organization/Event/FormsProvider'
import {Answer} from 'Event/SubmissionsProvider'

export default function SelectTestAttendeeDialog(props: {
  visible: boolean
  onClose: () => void
  onSelect: (attendee: Attendee | null, answers: Answer[]) => Promise<void>
  form: Form
}) {
  const {visible, onSelect, onClose, form} = props
  const [showSuccess, setShowSuccess] = useState<boolean>(false)
  const [value, setValue] = useState<Attendee | null>(null)
  const [loading, setLoading] = useState<boolean>(false)
  const [answers, setAnswers] = useState<Answer[]>([])

  const select = () => {
    setLoading(true)
    setShowSuccess(false)
    onSelect(value, answers)
      .then(() => {
        setShowSuccess(true)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  return (
    <Dialog
      open={visible}
      onClose={onClose}
      PaperProps={{
        style: {
          width: '100%',
          overflow: 'initial',
        },
      }}
    >
      <DialogTitle>Select attendee to test</DialogTitle>
      <StyledDialogContent>
        <Info>Select attendee for the webhook</Info>

        <TestAttendeeSearchField
          onChange={setValue}
          value={value}
          disabled={loading}
        />

        <CompletedTestForm
          form={form}
          answers={answers}
          setAnswers={setAnswers}
        />

        <StyledButton
          variant="contained"
          color="primary"
          disabled={loading}
          onClick={select}
        >
          Send test webhook
        </StyledButton>
        <SuccessAlert
          showing={showSuccess}
          onClose={() => {
            setShowSuccess(false)
          }}
        >
          Test webhook is send
        </SuccessAlert>
      </StyledDialogContent>
    </Dialog>
  )
}

const Info = styled.div`
  margin-bottom: ${(props) => props.theme.spacing[4]};
  font-size: 14px;
  font-style: italic;
`

const StyledButton = styled(Button)`
  height: 32px;
  align-self: center;
  font-size: 11px;
  margin-bottom: ${(props) => props.theme.spacing[4]};
`

const StyledDialogContent = styled(DialogContent)`
  overflow: initial;
  overflow: initial;
`
